import React from 'react';
import './motion.css';

const OUTER = '#465FFF';
const INNER = '#06B6D4';

export function DoubleRing({ size = 48 }) {
  return (
    <span className="svx-loader" role="status" aria-label="Loading">
      <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
        <circle className="svx-loader__outer" cx="24" cy="24" r="20" fill="none" stroke={OUTER} strokeWidth="4"
          strokeLinecap="round" pathLength="360" strokeDasharray="270 90" />
        <circle className="svx-loader__inner" cx="24" cy="24" r="12" fill="none" stroke={INNER} strokeWidth="4"
          strokeLinecap="round" pathLength="360" strokeDasharray="180 180" />
      </svg>
    </span>
  );
}

